<template>
  <div class="Header--wrapper" data-qa="zava-header" v-html="headerContent"></div>
</template>

<script>
import { getUrlLocale } from '@/helpers/url'

export default {
  name: 'ZavaHeader',
  data () {
    return {
      headerContent: ''
    }
  },
  beforeMount () {
    const locale = getUrlLocale()
    this.getHeader(locale)
  },
  methods: {
    async getHeader (locale) {
      try {
        const res = await fetch('/' + locale + '/header.html?name=porta')
        this.headerContent = await res.text()
      } catch (error) {
        if (window.newrelic) {
          window.newrelic.noticeError(error)
        }
      }
    }
  }
}
</script>
